import { InjectionToken } from '@angular/core';
import { type ChartId } from '@principle-theorem/ng-clinical-charting/store';

export const CHART_ENTITY_ID = new InjectionToken<ChartId>('chart-entity-id');
